// Today's plan at a glance: one rounded block per step, under "Today's plan". Ink is done, amber is next, gray is
// still to come, the same colors as the plan's ticks and the voice bars.
import type { VoiceBar } from './VoiceBars';

export function PlanBar({ steps, label }: { steps: readonly VoiceBar['state'][]; label: string }) {
  return (
    <div className="plan-bar" role="img" aria-label={label}>
      {steps.map((state, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: one block per plan step, in order.
        <i key={i} className={state} />
      ))}
    </div>
  );
}
